import React from 'react';
import { Button, Modal, Table } from 'semantic-ui-react';
import type { DraftSummaryDto } from '../../services/contracts/ContractService';

export interface ClientDraftsModalProps {
  open: boolean;
  drafts: DraftSummaryDto[];
  loading?: boolean;
  allowCreateNewDraft?: boolean;
  onContinue: (draftId: string) => void;
  onCreateNew: () => void;
  onClose: () => void;
  onChooseAnotherClient?: () => void;
}

export const ClientDraftsModal: React.FC<ClientDraftsModalProps> = ({
  open,
  drafts,
  loading = false,
  allowCreateNewDraft = true,
  onContinue,
  onCreateNew,
  onClose,
  onChooseAnotherClient,
}) => {
  const continueOnly = !allowCreateNewDraft;
  const dismissContinueOnly = onChooseAnotherClient ?? onClose;

  return (
  <Modal
    open={open}
    onClose={continueOnly ? dismissContinueOnly : onClose}
    size="small"
    closeIcon
    closeOnDimmerClick
    closeOnEscape
  >
    <Modal.Header>Rascunhos existentes</Modal.Header>
    <Modal.Content>
      <p>
        {continueOnly
          ? 'Este cliente já possui rascunho(s) de contrato. Continue um deles ou escolha outro cliente para criar um contrato novo.'
          : 'Este cliente já possui rascunho(s) de contrato. Deseja continuar um deles ou criar um novo?'}
      </p>
      {loading ? (
        <p>Carregando rascunhos...</p>
      ) : (
        <Table compact="very" striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Data</Table.HeaderCell>
              <Table.HeaderCell>Criador</Table.HeaderCell>
              <Table.HeaderCell>Linhas</Table.HeaderCell>
              <Table.HeaderCell>Tipo</Table.HeaderCell>
              <Table.HeaderCell />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {drafts.map((draft) => (
              <Table.Row key={draft.id}>
                <Table.Cell>{new Date(draft.createdAt).toLocaleString('pt-BR')}</Table.Cell>
                <Table.Cell>{draft.createdByUserName || '—'}</Table.Cell>
                <Table.Cell>{draft.lineCount}</Table.Cell>
                <Table.Cell>{draft.tipoContratacaoParcial || 'Rascunho'}</Table.Cell>
                <Table.Cell textAlign="right">
                  <Button size="small" primary onClick={() => onContinue(draft.id)}>
                    Continuar
                  </Button>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
    </Modal.Content>
    <Modal.Actions>
      {continueOnly ? (
        <Button onClick={dismissContinueOnly}>Escolher outro cliente</Button>
      ) : (
        <>
          <Button onClick={onClose}>Cancelar</Button>
          {allowCreateNewDraft && (
            <Button color="green" onClick={onCreateNew}>
              Criar novo rascunho
            </Button>
          )}
        </>
      )}
    </Modal.Actions>
  </Modal>
  );
};
